.titleRow {
  margin-top: 2em;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.title {
  flex: auto;
}

.back {
  max-width: 10em;
}
